export interface LogEntry {
  timestamp: string;
  level: string;
  message: string;
  service?: string;
  stack?: string;
  [key: string]: unknown;
}

const getAuthHeaders = (): Record<string, string> => {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  const user = localStorage.getItem('alertmanager_user');
  if (user) {
    try {
      const parsed = JSON.parse(user);
      if (parsed.token) headers['Authorization'] = `Bearer ${parsed.token}`;
    } catch {
      // ignore
    }
  }
  return headers;
};

export async function getLogs(limit = 500, level?: string): Promise<LogEntry[]> {
  const params = new URLSearchParams({ limit: limit.toString() });
  if (level && level !== 'all') params.append('level', level);
  const res = await fetch(`/api/logs?${params}`, { headers: getAuthHeaders() });
  if (!res.ok) throw new Error(`Failed to fetch logs: ${res.status}`);
  const data = await res.json();
  return data.logs;
}
